import {Notifications} from '@mantine/notifications';
import Head from 'next/head';
import {useRouter} from 'next/router';
import {useEffect, useState} from 'react';
import {TITLE_SUFFIX} from '../../../config/constants';
import {GSSKT_HOST} from '../../../config/constants/hosts';
import {useMediaQuery} from '../../../shared/services/useMediaQuery';
import {CommunityQuestionListPcComponent} from './Container/CommunityQuestionListPcComponent';
import {SpComponent} from './Container/Presenter/spComponent';
import {TagList} from './Container/TagList';

type Props = {
  selectedTagIdInitial: string;
  communityNickname: string;
  isSignedIn: boolean;
  isStudentVerificationRequired: boolean;
};

export const CommunityQuestionListPage: React.FC<Props> = ({
  selectedTagIdInitial,
  communityNickname,
  isSignedIn,
  isStudentVerificationRequired,
}: Props) => {
  const TITLE = `コミュニティ${TITLE_SUFFIX}`;
  const DESCRIPTION =
    '外資・日系トップ企業を目指す学生のための就職活動サイト「外資就活ドットコム」。トップ企業の新卒採用情報から、インターンシップ・先輩のエントリーシート・ES・体験記・コラム・TOEIC対策まで多様なコンテンツを掲載。';
  const KEYWORD =
    '外資,就活,インターンシップ,新卒採用,会社説明会,コラム,ES・体験記,投資銀行,コンサル,商社';
  const router = useRouter();
  const currentUrl = `${GSSKT_HOST}${decodeURI(router.asPath)}`;
  const {isPC} = useMediaQuery();

  const [selectedTagId, setSelectedTagId] =
    useState<string>(selectedTagIdInitial);

  useEffect(() => {
    if (selectedTagIdInitial) {
      setSelectedTagId(selectedTagIdInitial);
    }

    setSelectedTagId(router.query.tag as string);
  }, [selectedTagIdInitial, router.query.tag]);

  if (isPC === undefined) {
    return null;
  }

  return (
    <>
      <Head>
        <title key="title">{TITLE}</title>
        <meta key="og:title" property="og:title" content={TITLE} />
        <meta key="description" property="description" content={DESCRIPTION} />
        <meta
          key="og:description"
          property="og:description"
          content={DESCRIPTION}
        />
        <meta key="keywords" name="keywords" content={KEYWORD} />
        <meta key="og:url" property="og:url" content={currentUrl} />
        <meta name="robots" content="noindex" />
      </Head>
      <Notifications position={'top-right'} />
      {/* 左カラム */}
      {isPC && (
        <div className="w-[200px] mr-16 sticky">
          <TagList selectedTagId={selectedTagId} />
        </div>
      )}
      {/* 中央カラム */}
      <div className="w-full pc:w-[880px]">
        {isPC ? (
          <CommunityQuestionListPcComponent
            selectedTagId={selectedTagId}
            setSelectedTagId={setSelectedTagId}
            communityNickname={communityNickname}
            isSignedIn={isSignedIn}
            isStudentVerificationRequired={isStudentVerificationRequired}
          />
        ) : (
          <SpComponent />
        )}
      </div>
    </>
  );
};
